
import React, { Component, Fragment } from 'react'
import SortStoryDragContainerUI from './SortStoryDragContainerUI'
import SortStoryDropItemContainerUI from './SortStoryDropItemContainerUI'

class SortStoryActivityUI extends Component {

 
    componentWillReceiveProps=(props)=>{
        // if(this.activity.activityIndex!=props.activity.activityIndex){

        // }
    }

    render = () => {

        let { activity, quizViewer } = this.props
        let { quizViwerModel } = quizViewer.state
        let { dragItemList } = activity.dragContainerModel
        return (
            <Fragment>

                <SortStoryDragContainerUI activity={activity} quizViewer={quizViewer} />
                <SortStoryDropItemContainerUI activity={activity} quizViewer={quizViewer} />

            </Fragment>
        )
    }

}

export default SortStoryActivityUI